<template>
  <div
    v-if="contents.length"
    :class="[
      !isLabExperience && 'parent-content-tags',
      isLabExperience && 'parent-content-tags-labexperience',
    ]"
  >
    <span v-if="!isLabExperience" class="parent-content-tags__header">
      This {{ contentType }} appears in the following:
    </span>
    <ul v-if="!isLabExperience" :class="['parent-content-tags__list']">
      <li
        v-for="content in contents"
        :key="content.objectID"
        class="parent-content-tags__list-item"
      >
        <span class="parent-content-tags__list-item-tag">
          {{ CONTENT_TYPE_TITLES[content.content_type] }}
        </span>
        <span
          :class="['parent-content-tags__list-item-name']"
          @click="goToContent(content)"
        >
          {{ content.name }}
        </span>
      </li>
    </ul>
    <p
      v-if="isLabExperience"
      class="parent-content-tags-labexperience__header-labexperience"
    >
      Find similar labs in
      <span
        v-for="content in contents"
        :key="content.objectID"
        class="parent-content-tags-labexperience__list"
      >
        <router-link
          :to="{
            name: 'collection-detail',
            params: { id: content.objectID },
          }"
          class=" parent-content-tags-labexperience__list-item-name"
        >
          {{ content.name }}
        </router-link>
      </span>
      {{ contents.length > 1 ? ' collections.' : ' collection.' }}
    </p>
  </div>
</template>

<script>
import CONSTANTS from '@/constants'

export default {
  name: 'ParentContentTags',
  props: {
    contentType: {
      type: String,
      required: true,
    },
    contents: {
      type: Array,
      required: true,
      default: () => [],
    },
    isLabExperience: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data: () => {
    return {
      CONTENT_TYPE_TITLES: CONSTANTS.CONTENT_TYPE_TITLES,
    }
  },
  methods: {
    goToContent(content) {
      this.$router.push(this.$buildContentLink(content.content_type, content))
    },
  },
}
</script>

<style scoped lang="scss">
.parent-content-tags {
  font-family: var(--font-book);
  font-style: normal;
  font-weight: 450;
  font-size: rem(12px);
  line-height: rem(14px);
  color: var(--athens-gray);

  @include mobile {
    font-size: rem(12px);
    line-height: rem(14px);
  }

  &__header {
    font-family: var(--font-bold);
    font-weight: 700;
  }
  &__list {
    display: flex;
    flex-flow: column;
    gap: 5px;
    list-style-type: none;
    padding: 0;
    margin-top: 10px;
    &-item {
      display: flex;
      align-items: center;
      gap: 10px;

      &-tag {
        white-space: nowrap;
        padding: 1px 6px;
        background: var(--butterfly-bush);
        border-radius: 3px;
      }
      &-name {
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-decoration: underline;
        cursor: pointer;
      }
    }
  }

  &-labexperience {
    display: flex;
    align-items: center;
    font-family: var(--font-book);
    font-style: normal;
    color: var(--Secondary-Light-Blue-Gray, #afb0bf);
    font-size: 12px;
    font-weight: 450;
    line-height: 24px;

    &__list {
      margin: 0;
      display: inline;

      &-item-name {
        text-decoration: none;
        color: var(--Secondary-Purple-pale, #c9bbff) !important;
      }
      &:not(:last-child)::after {
        content: ',';
      }
    }
  }
}
</style>
